module.exports = __webpack_public_path__ + "audio-6cb782a24b6f.m4a";